import StoryPage from './story'
import storyFragment from './story.fragment'

export { storyFragment }

export default StoryPage
